import $axios from './apiConnection'
import axios from 'axios'
import instance from './apiConnectionExternal'
import parseCatch from '../helpers/handleErrors'
import store from '@/store/store'
import momentTimezone from 'moment-timezone'
import {GmtOffsetTypes} from '@/enum/gmt'

export function getDashboardGMTConfig () {
    const dashboardStore = store.getters['dashboards/getActiveDashboard']

    return dashboardStore.DashboardConf && 'GMTOffsetData' in dashboardStore.DashboardConf ? dashboardStore.DashboardConf.GMTOffsetData : {
        Type: GmtOffsetTypes.Browser
    }
}

export function getGmtOffset () {
    const GMTOffsetData = getDashboardGMTConfig()

    if (Number(GMTOffsetData.Type) === GmtOffsetTypes.Account) {
        const allAccounts =  store.getters['entities/getEntityList']('Accounts')
        const currentAccount = allAccounts.find(el => el.AccountID === Number(GMTOffsetData.AccountID))
        return currentAccount.GmtOffset
    } else if (Number(GMTOffsetData.Type) === GmtOffsetTypes.Browser) {
        return new Date().getTimezoneOffset() * 60 * -1
    } else {
        const GMTOffset = momentTimezone().tz(GMTOffsetData.GMTOffset).utcOffset() * 3600
        return GMTOffset / 60
    }
}

export const WidgetDataApi = {
    async getData(endPoint, requestConfig = {}) {
        try {
            const DashboardConf = getDashboardGMTConfig()
            const config = {
                ...requestConfig,
                headers: {
                    "x-GmtOffset": getGmtOffset(),
                    "GmtOffsetType": DashboardConf.Type
                }
            }

            let res = await $axios.post(endPoint, {}, config)
            return res.Data
        } catch (e) {
            if (axios.isCancel(e)) {
                return
            }
            parseCatch(e, true)
            return Promise.reject(e)
        }
    },

    async getExternalData(endPoint, requestConfig = {}) {
        try {
            let res = await instance.get(endPoint, requestConfig)
            return res.Data ? res.Data : res
        } catch (e) {
            if (axios.isCancel(e)) {
                return
            }
            parseCatch(e, true)
        }
    }
}
